import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TgGridModule, TgRackModule } from '@trademe/tangram';
import {
    SummaryAgentContactDetailModule
} from './summary-agent-contact-detail/summary-agent-contact-detail.module';
import {
    SummaryPageAgentContactDetailsSectionComponent
} from './summary-page-agent-contact-details-section.component';
@NgModule({
    imports: [CommonModule, TgRackModule, TgGridModule, SummaryAgentContactDetailModule],
    declarations: [SummaryPageAgentContactDetailsSectionComponent],
    exports: [SummaryPageAgentContactDetailsSectionComponent]
})
export class SummaryPageAgentContactDetailsSectionModule {}
